import { useState, useEffect } from 'react'

import { getProvincesAPI } from '../services/address'
import { getTrainingListPartnerAPI } from '../services/certificate'

function UseBrand() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const result = await getTrainingListPartnerAPI()
      if (!result) return

      const newData = result.result.length > 0 && result.result.map((d, i) => {
        return { value: d.partner, label: d.partner }
      })

      setData(newData)
    }
    getData()
  }, [])

  return data
}

export default UseBrand
